/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMustard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 8.17A3.001 3.001 0 0 0 5 11v12h14V11a3.001 3.001 0 0 0-2-2.83V7a2 2 0 0 0-1.945-2l-2.207-3.53a1 1 0 0 0-1.696 0L8.945 5A2 2 0 0 0 7 7zm5-4.283L12.696 5h-1.392zM8 10h8a1 1 0 0 1 1 1v10H7V11a1 1 0 0 1 1-1zm7-3v1H9V7zm-4 8.5c0-1.048.644-1.5 1-1.5s1 .452 1 1.5-.644 1.5-1 1.5-1-.452-1-1.5zm1-3.5c-1.854 0-3 1.787-3 3.5s1.146 3.5 3 3.5 3-1.787 3-3.5-1.146-3.5-3-3.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMustard as Mustard };
